interface Segment {
  x: number
  width: number
}

const hasSegmentsIntersection = (
  a: Segment,
  b: Segment,
  overlay = 0
): boolean => a.x + a.width >= b.x + overlay && a.x <= b.x + b.width - overlay

export interface Rectangle extends Segment {
  y: number
  height: number
}

export const hasRectIntersection = (
  a: Rectangle,
  b: Rectangle,
  overlay = 0
): boolean =>
  hasSegmentsIntersection(
    { x: a.x, width: a.width },
    {
      x: b.x,
      width: b.width,
    },
    overlay
  ) &&
  hasSegmentsIntersection(
    { x: a.y, width: a.height },
    { x: b.y, width: b.height },
    overlay
  )
